import { ContratoMenuModel } from './ContratoMenuModel';

export class ContratoModel {
    chave: String
    acesso_liberado: boolean
    data_expiracao: String

    static TIME_UM_DIA_COMPLETO: number = 86400000
    static QUANTIDADE_DIAS_AVISO_EXPIRACAO: number = 3

    getAcessoLiberado() {
        return this.acesso_liberado
    }

    getDataExpiracao(): String {
        return this.data_expiracao
    }

    static verificaMenuLiberadoPorContrato(contratoMenu: ContratoMenuModel, listaContrato: Array<ContratoModel>) {
        if (listaContrato) {
            for (let contrato of listaContrato) {
                if (contratoMenu.chaveContrato.indexOf(contrato.chave) >= 0 && contrato.acesso_liberado) {
                    return true;
                }
            }
        }
        return contratoMenu.nivelRestricao == ContratoMenuModel.NIVEL_RESTRICAO_BAIXO
    }

    static existeContratoPorChave(chaveContrato, listaContrato: Array<ContratoModel>) {
        if (listaContrato) {
            for (let contrato of listaContrato) {
                if (chaveContrato == contrato.chave && contrato.acesso_liberado) {
                    return true;
                }
            }
        }
        return false
    }

    static verificaContratoProximoExpirar(contratoMenu: ContratoMenuModel, listaContrato: Array<ContratoModel>) {
        if (listaContrato) {
            for (let contrato of listaContrato) {
                if (contratoMenu.chaveContrato.indexOf(contrato.chave) >= 0 && contrato.data_expiracao != null) {
                    let diferencaDias = this.obtemDiasParaExpiracaoDoContrato(contrato.data_expiracao.toString())
                    if (diferencaDias >= 0 && diferencaDias <= (this.TIME_UM_DIA_COMPLETO * this.QUANTIDADE_DIAS_AVISO_EXPIRACAO)) {
                        return true;
                    }
                }
            }
        }
        return false;
    }

    static obtemDiasParaExpiracaoDoContrato(dataExpiracao: string): number {
        try {
            let aux = new Date(dataExpiracao).getTime() - new Date().getTime()
            if (aux >= 0) {
                return aux;
            } else {
                throw Error()
            }
        } catch (e) {
            return -1;
        }
    }
}